import { useState, useEffect, useRef } from "react";
import { jsx } from "react/jsx-runtime";
import "./Contact.css";

function Contact() {
    const [fadeIn, setFadeIn] = useState({
        title: false,
        subtitle: false,
        twitter: false,
        email: false
    });

    useEffect(() => {
        // タイトルがフェードイン
        const titleTimer = setTimeout(() => {
            setFadeIn(prev => ({ ...prev, title: true }));
        }, 100);

        // サブタイトルがフェードイン
        const subtitleTimer = setTimeout(() => {
            setFadeIn(prev => ({ ...prev, subtitle: true }));
        }, 500);

        // Twitter情報がフェードイン
        const twitterTimer = setTimeout(() => {
            setFadeIn(prev => ({ ...prev, twitter: true }));
        }, 900);

        // Email情報がフェードイン
        const emailTimer = setTimeout(() => {
            setFadeIn(prev => ({ ...prev, email: true }));
        }, 1300);

        return () => {
            clearTimeout(titleTimer);
            clearTimeout(subtitleTimer);
            clearTimeout(twitterTimer);
            clearTimeout(emailTimer);
        };
    }, []);

    return (
        <div className="Contact">
            <title>Contact</title>
            <h1 className={`fade-in ${fadeIn.title ? 'active' : ''}`}>Contact</h1>
            <p className={`fade-in ${fadeIn.subtitle ? 'active' : ''}`}>お仕事の依頼やご質問はこちらから。<br/>
            システム開発から団体運用、オリジナル曲制作から編曲、Mixに至るまで、<br/>
            どんなことでもお気軽にお問合せ下さい。</p>
            <div className="contact-container">
                <div className={`contact-info fade-in ${fadeIn.twitter ? 'active' : ''}`}>
                    <h3>X(Twitter)</h3>
                    <img src="X-Icon.png" alt="X Icon" className="Icon" />
                    <a href="https://twitter.com/ijou_busoku">@ijou_busoku</a>
                </div>
                <div className={`contact-info fade-in ${fadeIn.email ? 'active' : ''}`}>
                    <h3>Email</h3>
                    <img src="Email-Icon.svg" alt="Email Icon" className="Icon" />
                    <a href="mailto:bugslove.music@gmail.com">bugslove.music@gmail.com</a>
                </div>
            </div>
        </div>

    );
}
export default Contact;